export const getTenantConfig = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const isSaml = searchParams.get("saml") === "true";

  // Try to get from localStorage first
  let storedConfig: any = localStorage.getItem("tenantConfig");
  let parsedConfig = storedConfig ? JSON.parse(storedConfig) : null;
  // If SAML login is attempted, or no config yet, update accordingly
  if (isSaml) {
    // If current config is DB_TENANT or empty, overwrite with SAML_TENANT
    if (!parsedConfig || parsedConfig.type !== "SAML_TENANT") {
      const samlConfig = {
        type: "SAML_TENANT",
        domain: window.appConfig.saml_auth0Config.domain,
        client_id: window.appConfig.saml_auth0Config.clientID,
        audience: window.appConfig.saml_auth0Config.audience,
        logoutRedirectUrl: window.appConfig.saml_auth0Config.logoutRedirectUrl,
        redirect_uri: window.appConfig.saml_auth0Config.loginRedirectUrl,
        scope: "openid profile email",
        leeway: 600,
        postLoginPath: "/dashboard-saml",
      };
      localStorage.setItem("tenantConfig", JSON.stringify(samlConfig));
      return samlConfig;
    }
    // Already SAML tenant, reuse it
    return parsedConfig;
  }

  // If not SAML — only use DB tenant if no SAML tenant exists
  if (!parsedConfig || parsedConfig.type === "DB_TENANT") {
    console.log("If not SAML");
    const dbConfig = {
      type: "DB_TENANT",
      domain: window.appConfig.auth0Config.domain,
      client_id: window.appConfig.auth0Config.clientID,
      auth0ConnectionName: window.appConfig.auth0Config.connection,
      audience: window.appConfig.auth0Config.audience,
      logoutRedirectUrl: window.appConfig.auth0Config.logoutRedirectUrl,
      redirect_uri: window.appConfig.auth0Config.loginRedirectUrl,
      leeway: 600,
      postLoginPath: "/dashboard-saml",
      scope: "openid profile email",
    };
    localStorage.setItem("tenantConfig", JSON.stringify(dbConfig));
    return dbConfig;
  }

  // If existing config is SAML and not trying SAML, keep SAML
  return parsedConfig;
};
